import { DARK_GRADIENT, LIGHT_GRADIENT } from "@/components/backgrounds/gradient-constants";
import FreeCreditsPromotionBanner from "@/routes/ona-onboarding/FreeCreditsPromotionBanner";
import { OnboardingHeader } from "@/routes/ona-onboarding/OnboardingHeader";
import type { FC, ReactNode } from "react";

type OnboardingLayoutProps = {
    children: ReactNode;
    showcase: ReactNode;
};

export const OnboardingLayout: FC<OnboardingLayoutProps> = ({ children, showcase }) => {
    return (
        <div className="flex h-full min-h-screen w-full flex-col md:flex-row">
            {/* Left panel — header + form + banner */}
            <div className="flex w-full flex-1 flex-col bg-surface-primary md:w-1/2 md:border-r md:border-border-base">
                <OnboardingHeader />

                {/* Centered form content */}
                <div className="flex flex-1 animate-fade-in flex-col items-center justify-center px-6 py-8 md:px-16">
                    {children}
                </div>

                {/* Banner pinned to bottom */}
                <FreeCreditsPromotionBanner className="w-full rounded-none border-t border-t-border-subtle bg-surface-base dark:bg-surface-base" />
            </div>

            {/* Right panel — gradient background matching /login (hidden on mobile) */}
            <div className="relative hidden md:block md:w-1/2">
                <div className="absolute inset-0 dark:hidden" style={{ background: LIGHT_GRADIENT }} />
                <div className="absolute inset-0 hidden dark:block" style={{ background: DARK_GRADIENT }} />
                <div className="relative flex h-full w-full animate-fade-in items-center justify-center p-16">
                    {showcase}
                </div>
            </div>
        </div>
    );
};
